import React from 'react';
import FeatureCard from 'components/FeatureCard';
import { featureGroups, positioningStatement } from 'content/landingContent';

/**
 * Grouped feature section. Renders the shipped capability set as four scannable
 * themes, with "Coming soon" badges on capabilities that are not live yet, plus
 * the explicit "independent artists, not studios" positioning statement.
 */
const LandingFeatures: React.FC = () => (
  <section id="features" className="mx-auto max-w-6xl px-5 py-16">
    <h2 className="text-3xl font-bold text-[#2f2f2d]">
      Everything you need to run your booking pipeline
    </h2>
    <p className="mt-2 max-w-2xl text-[#2f2f2d]/80">{positioningStatement}</p>

    <div className="mt-10 space-y-12">
      {featureGroups.map((group) => (
        <div key={group.title}>
          <h3 className="text-xl font-bold text-[#2f2f2d]">{group.title}</h3>
          <p className="mt-1 text-sm text-[#2f2f2d]/70">{group.description}</p>
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {group.features.map((feature) => (
              <FeatureCard
                key={feature.title}
                title={feature.title}
                description={feature.description}
                comingSoon={feature.isComingSoon}
                headingLevel={4}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default LandingFeatures;
